<template>
  <div class="hello">
    <canvas name="msg" :uri="val" :width="width" :height="height"></canvas>
  </div>
</template>
<script>
  import QRCode from 'qrcode'

  export default {
    name: 'BarCode',
    componentName: 'BarCode',
    provide() {
      return {
        BarCode: this
      };
    },
    data() {
      return {
        val: ""
      }
    },
    props: {
      content: String,
      width: {type: String, default: "200px"},
      height: {type: String, default: "200px"}
    },
    mounted() {
      this.val = this.content;
    },
    methods: {
      createBarCode() {
        let that = this;
        let msg = document.getElementsByName("msg");//getElementById('msg');
        if(msg && msg.length>0){
          msg.forEach((e)=>{
            QRCode.toCanvas(e, e.getAttribute("uri"), function (error) {
              that.$emit("onError", error);
            })
          });
        }
      },
      f_create(val) {
        this.val = val;
      }
    },
    watch: {
      content(nv, ov) {
        if (nv && nv !== ov) {
          this.val = nv;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BarCode.vue